import { RendererService } from './../renderer.service';
import { Component, OnInit } from '@angular/core';
import {EntityComponent} from '../share/entity-component';
import {UserDefinedModel} from '../../model';
import {SceneService} from '../scene.service';
import {
  Geometry, Line,  LineBasicMaterial,  Vector2, Vector3
} from 'three';

@Component({
  selector: 'ng3-shape',
  templateUrl: './shape.component.html',
  styleUrls: ['./shape.component.css'],
})
export class ShapeComponent extends EntityComponent<UserDefinedModel> {

  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }
  createEntity(model: UserDefinedModel) {
    // const result = new Points(new ShapeGeometry(model.shapes),
    //   new PointsMaterial({size: 1.0})
    // );
    const geo = new Geometry();
    for (let i = 0; i < model.shapes.length; i ++) {
      const pos = this.sceneService.clientPosition2ScenePosition(model.shapes[i]);
      // pos = this.sceneService.clientSize2SceneSize(pos);
      geo.vertices.push(new Vector3(pos.x, pos.y, 0));
    }
    geo.vertices.push(new Vector3(
      this.sceneService.clientPosition2ScenePosition(model.shapes[0]).x,
      this.sceneService.clientPosition2ScenePosition(model.shapes[0]).y,
      0));
    const result = new Line(geo, new LineBasicMaterial({color: 0xffff00, linewidth: 1}));
    result.name = 'user-defined';
    return result;
  }
  updateEntity(model: UserDefinedModel, entity: Line) {
    // const shape = new Shape();
    // shape.absarc(0, 0, 20, 0, 0.5 * Math.PI, true);
    const geo = new Geometry();
    for (let i = 0; i < model.shapes.length; i ++) {
        const pos = this.sceneService.clientPosition2ScenePosition(model.shapes[i]);
        // pos = this.sceneService.clientSize2SceneSize(pos);
       geo.vertices.push(new Vector3(pos.x, pos.y, 0));
    }
    geo.vertices.push(new Vector3(
      this.sceneService.clientPosition2ScenePosition(model.shapes[0]).x,
      this.sceneService.clientPosition2ScenePosition(model.shapes[0]).y,
      0));
    entity.geometry = geo;
    return entity;
  }
  defaultModel() {
    const shapeTemp: Vector2[] = [];
    shapeTemp.push(new Vector2(-5, 5));
    shapeTemp.push(new Vector2(-5, -5));
    shapeTemp.push(new Vector2(5, -5));
    shapeTemp.push(new Vector2(5, 5));
    shapeTemp.push(new Vector2(-5, 5));
    return new UserDefinedModel(
      shapeTemp
      );
  }
}
